import { LANE_INDEXES, TABLE_IDS, cellId, parseCellId, } from '@cards/engine';
import { FragmentCard, ReconstructedRobotCard } from './tokens.js';
export function ownerSide(ctx, ownerId) {
    return ctx.q.player(ownerId).side;
}
export function cellsInLocation(tableId, side) {
    return LANE_INDEXES.map((laneIndex) => cellId(tableId, laneIndex, side));
}
export function locationHasSpace(ctx, tableId, side) {
    return cellsInLocation(tableId, side).some((id) => ctx.q.cell(id)?.occupantId === null);
}
export function fragmentCount(ctx, ownerId, tableId) {
    return ctx.q.unitsOf(ownerId).filter((unit) => unit.defId === FragmentCard.id && unit.cellId !== undefined && parseCellId(unit.cellId).tableId === tableId).length;
}
export function fragmentLocationsByPriority(ctx, ownerId) {
    const side = ownerSide(ctx, ownerId);
    return [...TABLE_IDS]
        .filter((tableId) => locationHasSpace(ctx, tableId, side))
        .sort((a, b) => {
        const aHasFragment = fragmentCount(ctx, ownerId, a) > 0 ? 1 : 0;
        const bHasFragment = fragmentCount(ctx, ownerId, b) > 0 ? 1 : 0;
        return bHasFragment - aHasFragment || a - b;
    });
}
export function plannedCell(ctx) {
    return ctx.plan?.kind === 'SPELL' ? ctx.plan.targetCellId : undefined;
}
export function plannedUnit(ctx) {
    return ctx.plan?.kind === 'SPELL' ? ctx.plan.targetInstanceId : undefined;
}
export function tableOf(cell) {
    return parseCellId(cell).tableId;
}
function completeCurrentAssembly(ctx, ownerId, tableId) {
    const pair = ctx.q.unitsOf(ownerId).filter((unit) => unit.defId === FragmentCard.id && unit.cellId !== undefined && parseCellId(unit.cellId).tableId === tableId).slice(0, 2);
    if (pair.length < 2)
        return false;
    ctx.ops.completeAssembly(ownerId, [pair[0].id, pair[1].id], ReconstructedRobotCard.id);
    return true;
}
export function createFragmentInLocation(ctx, ownerId, tableId) {
    const created = ctx.ops.createTokenInLocation(FragmentCard.id, ownerId, tableId);
    return { created, assembled: created !== null && completeCurrentAssembly(ctx, ownerId, tableId) };
}
export function createFragmentAtCell(ctx, ownerId, targetCellId) {
    const created = ctx.ops.tryCreateToken(FragmentCard.id, ownerId, targetCellId);
    return {
        created,
        assembled: created !== null && completeCurrentAssembly(ctx, ownerId, tableOf(targetCellId)),
    };
}
//# sourceMappingURL=helpers.js.map